// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PatientSearch.css */

.patient-search-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .patient-search-container label {
    font-weight: 600;
    color: #333;
  }
  
  .patient-search-container input {
    width: 100%;
    padding: 10px 14px;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 6px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }
  
  .patient-search-container input:focus {
    border-color: var(--clr-primary-3);
    outline: none;
    box-shadow: 0 0 0 2px rgba(100, 150, 250, 0.2);
  }
  
  /* Dropdown list */
  .patient-list {
    list-style: none;
    padding: 0;
    margin: 0;
    border: 1px solid #ddd;
    border-radius: 6px;
    background: #fff;
    max-height: 180px;
    overflow-y: auto;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    animation: dropdownFade 0.2s ease;
  }
  
  .patient-list li {
    padding: 10px 14px;
    cursor: pointer;
    font-size: 0.95rem;
    transition: background-color 0.2s ease;
  }
  
  .patient-list li:hover {
    background-color: #f3f6fa;
  }
  
  @keyframes dropdownFade {
    from {
      opacity: 0;
      transform: translateY(-4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/AdminScheduling/SchedulingStyles/PatientSearch.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,wDAAwD;EAC1D;;EAEA;IACE,kCAAkC;IAClC,aAAa;IACb,8CAA8C;EAChD;;EAEA,kBAAkB;EAClB;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF","sourcesContent":["/* PatientSearch.css */\n\n.patient-search-container {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .patient-search-container label {\n    font-weight: 600;\n    color: #333;\n  }\n  \n  .patient-search-container input {\n    width: 100%;\n    padding: 10px 14px;\n    font-size: 1rem;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  }\n  \n  .patient-search-container input:focus {\n    border-color: var(--clr-primary-3);\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(100, 150, 250, 0.2);\n  }\n  \n  /* Dropdown list */\n  .patient-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    background: #fff;\n    max-height: 180px;\n    overflow-y: auto;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n    animation: dropdownFade 0.2s ease;\n  }\n  \n  .patient-list li {\n    padding: 10px 14px;\n    cursor: pointer;\n    font-size: 0.95rem;\n    transition: background-color 0.2s ease;\n  }\n  \n  .patient-list li:hover {\n    background-color: #f3f6fa;\n  }\n  \n  @keyframes dropdownFade {\n    from {\n      opacity: 0;\n      transform: translateY(-4px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
